const advantages = [
  {
    icon: 'ri-user-star-line',
    title: 'Analyse Professionnelle',
    description: 'Évaluation experte de votre situation pour des conseils personnalisés et adaptés à votre profil unique.'
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Conseils Clairs & Stratégiques',
    description: 'Guidance transparente et stratégies éprouvées pour maximiser vos chances de succès.'
  },
  {
    icon: 'ri-file-shield-2-line',
    title: 'Dossiers de Qualité Irréprochable',
    description: 'Constitution de dossiers complets, cohérents et conformes aux exigences consulaires les plus strictes.'
  },
  {
    icon: 'ri-emotion-happy-line',
    title: 'Taux de Satisfaction Élevé',
    description: 'Plus de 98% de nos clients sont satisfaits de nos services et recommandent Clé Visa.'
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Respect des Exigences Consulaires',
    description: 'Connaissance approfondie des procédures et respect strict des normes de chaque consulat.'
  },
  {
    icon: 'ri-time-line',
    title: 'Disponibilité & Rapidité',
    description: 'Réactivité exceptionnelle et traitement rapide de vos demandes pour respecter vos délais.'
  },
  {
    icon: 'ri-eye-line',
    title: 'Transparence Totale',
    description: 'Communication claire sur les étapes, les coûts et les délais. Aucune surprise, que des résultats.'
  },
  {
    icon: 'ri-award-line',
    title: 'Expertise Reconnue',
    description: 'Des années d\'expérience et des centaines de visas obtenus pour nos clients satisfaits.'
  }
];

export default function AdvantagesSection() {
  return (
    <section id="avantages" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-blue-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-star-line text-blue-600"></i>
            <span className="text-blue-700 text-sm font-semibold">Pourquoi Nous Choisir</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Les Avantages Clé Visa
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Avec Clé Visa, vous prenez les bonnes décisions pour maximiser vos chances d'obtenir votre visa
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {advantages.map((advantage, index) => (
            <div 
              key={index}
              className="text-center group"
            >
              <div className="w-20 h-20 bg-gradient-to-br from-teal-100 to-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-md">
                <i className={`${advantage.icon} text-4xl text-teal-600`}></i>
              </div>
              
              <h3 className="text-lg font-bold text-gray-900 mb-3">
                {advantage.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {advantage.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-gradient-to-br from-teal-600 to-blue-900 rounded-3xl p-12 text-center text-white shadow-2xl">
          <h3 className="text-3xl md:text-4xl font-bold mb-6">
            Prêt à Commencer Votre Projet ?
          </h3>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Contactez-nous dès aujourd'hui pour une consultation gratuite et découvrez comment nous pouvons vous aider.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://wa.me/22892620409" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-white text-teal-600 px-8 py-4 rounded-full hover:bg-gray-100 transition-all font-semibold text-lg shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2 text-xl"></i>
              WhatsApp: +228 92 62 04 09
            </a>
            <a 
              href="mailto:clevisa22@gmail.com"
              className="inline-flex items-center bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full hover:bg-white/20 transition-all font-semibold text-lg border-2 border-white/30 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2 text-xl"></i>
              clevisa22@gmail.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
